/**
 * Handles the on click event for the fly out captions
 */


const flyOutCaptions = () => {
	const flyOutCaptionsTrigger = Array.from(document.querySelectorAll('.fly-out-caption__trigger'));

	if (!flyOutCaptionsTrigger.length) return;

	const handleCaptionTrigger = function() {
		this.classList.toggle('expanded');
	}

	flyOutCaptionsTrigger.forEach(trigger => {
		trigger.addEventListener('click', handleCaptionTrigger);
	});
}

export default flyOutCaptions;
